import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from '../layout/Dashboard';
import { HolidaysSettings } from '../../components/pages/appointments/HolidaysSettings';
import {
  PageHeader,
  PageWorkspace
} from '../../components/layout/Workspace';
import './SettingsAppointments.scss';

function SettingsAppointmentsComponent(props) {
  return (
    <DashboardLayout pageTitle={<FormattedMessage id="app.dashboard.page_title"/>} workspace {...props}>
      <PageWorkspace className="appointment-settings-workspace">
        <PageHeader title={<FormattedMessage id="components.pages.appointments.holidays_settings.title"/>}/>
        <HolidaysSettings/>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const SettingsAppointments = connect(null, { hideNotification })(SettingsAppointmentsComponent);

export { SettingsAppointments, SettingsAppointmentsComponent };
